/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */
/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

// ### onClickOutside
// Listen for clicks that occur somewhere in the document, outside of the element itself
import onClickOutside from 'react-onclickoutside';
import MenuDropdown from './menu-dropdown';

export default onClickOutside(MenuDropdown);



// WEBPACK FOOTER //
// ./components/menu-dropdown/index.jsx